import { AsyncPipe, DatePipe, JsonPipe, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySnackBarModule, MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import {
  MatLegacyTableDataSource as MatTableDataSource,
  MatLegacyTableModule as MatTableModule,
} from '@angular/material/legacy-table';
import { CuttingStaticDocument, ICustomResponse, PipesModule, downloadFile } from 'cloud-shared-lib';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { CdkTableModule } from '@angular/cdk/table';
import { OrderDetailService } from '../../order-detail.service';

@Component({
  selector: 'cutting-static-documents',
  templateUrl: './static-documents.component.html',
  styleUrls: ['./static-documents.component.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    NgIf,
    DatePipe,
    JsonPipe,
    PipesModule,
    MatIconModule,
    CdkTableModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatLegacySnackBarModule,
  ],
})
export class StaticDocumentsComponent {
  @Input() publicApiKey = '';

  displayedColumns = ['name', 'type', 'size', 'date', 'download', 'print'];
  dataSource: MatTableDataSource<CuttingStaticDocument> = new MatTableDataSource();
  downloading: Set<number> = new Set();

  documents$: Observable<ICustomResponse<CuttingStaticDocument[]>>;

  constructor(private orderDetailService: OrderDetailService, private snackBar: MatSnackBar) {
    this.documents$ = this.orderDetailService
      .getStaticDocuments(this.orderDetailService.order.id)
      .pipe(tap(res => (this.dataSource.data = res.result)));
  }

  downloadOrderDocument(item: CuttingStaticDocument): void {
    this.downloading.add(item.id);

    this.orderDetailService.downloadCustomDocument(item.id).subscribe(
      response => {
        downloadFile(response, item.name + item.extension);
        this.downloading.delete(item.id);
      },
      () => {
        this.snackBar.open($localize`Не удалось скачать файл`);
        this.downloading.delete(item.id);
      }
    );
  }
}
